import {
  GET_PAYROLLCOMPONENT,
  GET_PAYROLLCOMPONENT_SUCCESS,
  GET_PAYROLLCOMPONENT_FAIL,
  DELETE_PAYROLLCOMPONENT,
  DELETE_PAYROLLCOMPONENT_SUCCESS,
  DELETE_PAYROLLCOMPONENT_FAIL,
  UPDATE_PAYROLLCOMPONENT,
  UPDATE_PAYROLLCOMPONENT_SUCCESS,
  UPDATE_PAYROLLCOMPONENT_FAIL,
  ADD_NEW_PAYROLLCOMPONENT,
  ADD_PAYROLLCOMPONENT_SUCCESS,
  ADD_PAYROLLCOMPONENT_FAIL,
  PAYROLLCOMPONENT_LOADING,
  PAYROLLCOMPONENT_RESET,
} from "./actionType";

export const resetPayrollComponentState = (actionType) => ({
  type: PAYROLLCOMPONENT_RESET,
  payload: { actionType },
});

export const getPayrollComponentSuccess = (actionType, data) => ({
  type: GET_PAYROLLCOMPONENT_SUCCESS,
  payload: { actionType, data },
});

export const getPayrollComponentFail = (actionType, error) => ({
  type: GET_PAYROLLCOMPONENT_FAIL,
  payload: { actionType, error },
});

export const getPayrollComponent = data => ({
  type: GET_PAYROLLCOMPONENT,
  payload: data,
});

export const getPayrollComponentLoading = () => ({
  type: PAYROLLCOMPONENT_LOADING
});

export const deletePayrollComponent = data => ({
  type: DELETE_PAYROLLCOMPONENT,
  payload: data,
});

export const deletePayrollComponentSuccess = data => ({
  type: DELETE_PAYROLLCOMPONENT_SUCCESS,
  payload: data,
});

export const deletePayrollComponentFail = error => ({
  type: DELETE_PAYROLLCOMPONENT_FAIL,
  payload: error,
});

export const updatePayrollComponent = data => ({
  type: UPDATE_PAYROLLCOMPONENT,
  payload: data,
});

export const updatePayrollComponentFail = error => ({
  type: UPDATE_PAYROLLCOMPONENT_FAIL,
  payload: error,
});

export const updatePayrollComponentSuccess = data => ({
  type: UPDATE_PAYROLLCOMPONENT_SUCCESS,
  payload: data,
});

export const addNewPayrollComponent = data => ({
  type: ADD_NEW_PAYROLLCOMPONENT,
  payload: data,
});

export const addPayrollComponentSuccess = data => ({
  type: ADD_PAYROLLCOMPONENT_SUCCESS,
  payload: data,
});

export const addPayrollComponentFail = error => ({
  type: ADD_PAYROLLCOMPONENT_FAIL,
  payload: error,
});